(() => {
 'use strict';
 function mount(root){
  if(root.dataset.obravistaMounted)return;root.dataset.obravistaMounted='true';
  const open=root.querySelector('[data-obravista-open]'),close=root.querySelector('[data-obravista-close]'),slot=root.querySelector('[data-obravista-slot]');
  let frame;
  function configure(){
   if(!frame)return;
   const style=getComputedStyle(root),font=style.fontFamily;
   let surface=root;while(surface.parentElement&&getComputedStyle(surface).backgroundColor==='rgba(0, 0, 0, 0)')surface=surface.parentElement;const rgb=getComputedStyle(surface).backgroundColor.match(/[\d.]+/g)||[18,18,20];const defaultTheme=(Number(rgb[0])+Number(rgb[1])+Number(rgb[2]))/3<128?'dark':'light';let artwork=null;try{artwork=JSON.parse(root.querySelector('[data-obravista-artwork]').textContent);}catch{}
   frame.contentWindow.postMessage({type:'metaoffset-obravista-config',font,artwork,defaultTheme},location.origin);
  }
  const receive=event=>{
   if(!frame||event.source!==frame.contentWindow||event.origin!==location.origin)return;
   if(event.data?.type==='metaoffset-obravista-ready')configure();
   if(event.data?.type==='metaoffset-obravista-height'&&Number.isFinite(event.data.height))frame.style.height=Math.max(500,Math.min(6000,event.data.height))+'px';
  };
  window.addEventListener('message',receive);
  open.addEventListener('click',()=>{
   if(!frame){slot.append(root.querySelector('template').content.cloneNode(true));frame=slot.querySelector('iframe');}
   slot.hidden=false;close.hidden=false;open.hidden=true;open.setAttribute('aria-expanded','true');frame.focus({preventScroll:true});slot.scrollIntoView({block:'start',behavior:'auto'});
  });
  close.addEventListener('click',()=>{slot.hidden=true;close.hidden=true;open.hidden=false;open.setAttribute('aria-expanded','false');open.focus();});
  root.addEventListener('shopify:section:unload',()=>window.removeEventListener('message',receive),{once:true});
 }
 document.querySelectorAll('[data-metaoffset-obravista]').forEach(mount);
 document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-metaoffset-obravista]').forEach(mount));
})();
